var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Grid, IconButton, Skeleton, styled, Typography } from "@mui/material";
import { t } from "i18next";
import moment from "moment";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CorrectiveActionsListUrl, getAlertDetailsURL, JobcardAlertUpsertUrl, ReapeatRootCauseCategoryListUrl, ReapeatRootCauseListUrl, RepeatRevisitConfigUrl } from "../../api/url";
import { ArrowDownIcon, ArrowUPIcon, PhoneIcon } from "../../assets/images";
import { InputBox, MuiButton, MuiStack } from "../../components";
import { MuiSelectComponent } from "../../components/atoms/muiSelectComponent";
import SkeletonLoader from "../../components/atoms/sketeton";
import { AlertFields, E_Channel_Name, JC_ALERT_CONFIG_LEVELS, LOCAL_STORAGE_KEYS, REPEAT_SHOW_HIDE_CONFIG_CV, REPEAT_SHOW_HIDE_CONFIG_MC, REPEAT_SHOW_HIDE_CONFIG_PB, RepeatAlertConfigAdditionalDefination, RepeatAlertResolutionConfiguration } from "../../constants";
import { showLoader, showNotification } from "../../redux/commonSlice";
import { createAPI, getListAPI, setState } from "../../redux/crudSlice";
import { useAppDispatch } from "../../store/hooks";
import { faintblue, faintGray, gray, mobilenoblack } from "../../theme/palette";
import { systemColor } from "../../theme/systemColor";
import { getLocalStorageItem } from "../../utils/storageHelper";
import { GoogleAnlyticsErrorLog, handleMobileNoPhoneCall } from "../../utils/utils";
var Img = styled("img")(function (_ref) {
    var theme = _ref.theme;
    return {
        height: "18px",
        marginRight: "5px",
        width: "18px"
    };
});
export var AlertDetailsRepeat = function (props) {
    var _alertDetails$Organiz, _alertDetails$Organiz2, _alertDetails$Organiz3, _alertDetails$Organiz4;
    var repeatRevisitReasonListHeaderLevel = props.repeatRevisitReasonListHeaderLevel, repeatRevisitReasonListLineLevel = props.repeatRevisitReasonListLineLevel, alertId = props.alertId, jobCardId = props.jobCardId, previousJobcard = props.previousJobcard, toggleDrawer = props.toggleDrawer, InstallBaseId = props.InstallBaseId, callApIStatus = props.callApIStatus, isCreateDocumentFlow = props.isCreateDocumentFlow, isDocumentDisabled = props.isDocumentDisabled, documentStatusKey = props.documentStatusKey;
    var _a = useState(false), isExpand = _a[0], setIsExpand = _a[1];
    var _b = useState(false), isExpandParent = _b[0], setIsExpandParent = _b[1];
    var _c = useState(null), alertDetails = _c[0], setAlertDetails = _c[1];
    var _d = useState(null), repeatReasonConfig = _d[0], setRepeatReasonConfig = _d[1];
    var _e = useState(""), repeatRevisitId = _e[0], setRepeatRevisitId = _e[1];
    var _f = useState(""), rootCauseCategoryId = _f[0], setRootCauseCategoryId = _f[1];
    var _g = useState(""), rootCauseId = _g[0], setRootCauseId = _g[1];
    var _h = useState(""), correctiveActionId = _h[0], setCorrectiveActionId = _h[1];
    var _j = useState(""), remarks = _j[0], setRemarks = _j[1];
    var _k = useState([]), rootCauseList = _k[0], setRootCauseList = _k[1];
    var _l = useState([]), rootCauseCategoryList = _l[0], setRootCauseCategoryList = _l[1];
    var _m = useState([]), correctiveActionList = _m[0], setCorrectiveActionList = _m[1];
    var _o = useState([]), PartLabourComplaintList = _o[0], setPartLabourComplaintList = _o[1];
    var storedSelectedChannel = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_CHANNEL);
    var REPEAT_SHOW_HIDE_CONFIG = (storedSelectedChannel === null || storedSelectedChannel === void 0 ? void 0 : storedSelectedChannel.ChannelName) === E_Channel_Name.CV ? REPEAT_SHOW_HIDE_CONFIG_CV : (storedSelectedChannel === null || storedSelectedChannel === void 0 ? void 0 : storedSelectedChannel.ChannelName) === E_Channel_Name.MC ? REPEAT_SHOW_HIDE_CONFIG_MC : REPEAT_SHOW_HIDE_CONFIG_PB;
    var _p = useState(false), previousJobcardLoader = _p[0], setPreviousJobcardLoader = _p[1];
    var profileData = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA);
    var _q = useState({
        repeatListLoader: false,
        categoryListLoader: false,
        rootCauseListLoader: false,
        correctiveActionListLoader: false
    }), listLoader = _q[0], setListLoader = _q[1];
    var dispatch = useAppDispatch();
    var navigate = useNavigate();
    var getAlertDetailsById = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _result$payload, _result$payload2, requestBody, result, _result$payload3, _result$payload4, _result$payload6, _result$payload8, _result$payload10, _result$payload13, _result$payload16, _result$payload19, _result$payload20, partList, labourList, ComplaintList, _result$payload5, _result$payload7, _result$payload9, _result$payload11, _result$payload12, categoryList, _result$payload14, _result$payload15, rootCauseList_1, _result$payload17, _result$payload18, correctiveList;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setPreviousJobcardLoader(true);
                    setListLoader({
                        repeatListLoader: true,
                        categoryListLoader: true,
                        rootCauseListLoader: true,
                        correctiveActionListLoader: true
                    });
                    requestBody = {
                        AlertId: alertId,
                        InstallBaseId: InstallBaseId
                    };
                    if (isCreateDocumentFlow) {
                        requestBody.SystemName = null;
                    }
                    else {
                        requestBody.ParentId = jobCardId;
                        requestBody.SystemName = documentStatusKey;
                    }
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: '',
                            url: getAlertDetailsURL,
                            request: requestBody
                        }))];
                case 1:
                    result = _a.sent();
                    if (!(result !== null && result !== void 0 && (_result$payload = result.payload) !== null && _result$payload !== void 0 && (_result$payload = _result$payload.value) !== null && _result$payload !== void 0 && _result$payload.success && result !== null && result !== void 0 && (_result$payload2 = result.payload) !== null && _result$payload2 !== void 0 && (_result$payload2 = _result$payload2.value) !== null && _result$payload2 !== void 0 && _result$payload2.data)) return [3 /*break*/, 8];
                    setAlertDetails(result === null || result === void 0 || (_result$payload3 = result.payload) === null || _result$payload3 === void 0 || (_result$payload3 = _result$payload3.value) === null || _result$payload3 === void 0 ? void 0 : _result$payload3.data);
                    partList = [];
                    labourList = [];
                    ComplaintList = [];
                    if (result !== null && result !== void 0 && (_result$payload4 = result.payload) !== null && _result$payload4 !== void 0 && (_result$payload4 = _result$payload4.value) !== null && _result$payload4 !== void 0 && (_result$payload4 = _result$payload4.data) !== null && _result$payload4 !== void 0 && _result$payload4.Part) {
                        partList = __spreadArray([], (result === null || result === void 0 || (_result$payload5 = result.payload) === null || _result$payload5 === void 0 || (_result$payload5 = _result$payload5.value) === null || _result$payload5 === void 0 || (_result$payload5 = _result$payload5.data) === null || _result$payload5 === void 0 ? void 0 : _result$payload5.Part), true);
                        partList = partList.map(function (partItem) {
                            return _objectSpread(_objectSpread({}, partItem), {}, {
                                isExpanded: false,
                                jobType: "Part",
                                code: partItem.PartCode,
                                RepeatRevisitReasonId: partItem.RepeatRevisitReasonId ? partItem.RepeatRevisitReasonId : "",
                                rootCauseCategoryId: partItem.RepeatRootCauseId ? partItem.RepeatRootCauseId : "",
                                rootCauseId: partItem.SpecificRepeatRootCauseId ? partItem.SpecificRepeatRootCauseId : "",
                                CorrectiveActionId: partItem.CorrectiveActionId ? partItem.CorrectiveActionId : ""
                            });
                        });
                    }
                    if (result !== null && result !== void 0 && (_result$payload6 = result.payload) !== null && _result$payload6 !== void 0 && (_result$payload6 = _result$payload6.value) !== null && _result$payload6 !== void 0 && (_result$payload6 = _result$payload6.data) !== null && _result$payload6 !== void 0 && _result$payload6.Labour) {
                        labourList = __spreadArray([], (result === null || result === void 0 || (_result$payload7 = result.payload) === null || _result$payload7 === void 0 || (_result$payload7 = _result$payload7.value) === null || _result$payload7 === void 0 || (_result$payload7 = _result$payload7.data) === null || _result$payload7 === void 0 ? void 0 : _result$payload7.Labour), true);
                        labourList = labourList.map(function (labourItem) {
                            return _objectSpread(_objectSpread({}, labourItem), {}, {
                                isExpanded: false,
                                jobType: "Labour",
                                code: labourItem.LabourCode,
                                RepeatRevisitReasonId: labourItem.RepeatRevisitReasonId ? labourItem.RepeatRevisitReasonId : "",
                                rootCauseCategoryId: labourItem.RepeatRootCauseId ? labourItem.RepeatRootCauseId : "",
                                rootCauseId: labourItem.SpecificRepeatRootCauseId ? labourItem.SpecificRepeatRootCauseId : "",
                                CorrectiveActionId: labourItem.CorrectiveActionId ? labourItem.CorrectiveActionId : ""
                            });
                        });
                    }
                    if (result !== null && result !== void 0 && (_result$payload8 = result.payload) !== null && _result$payload8 !== void 0 && (_result$payload8 = _result$payload8.value) !== null && _result$payload8 !== void 0 && (_result$payload8 = _result$payload8.data) !== null && _result$payload8 !== void 0 && _result$payload8.Complaint) {
                        ComplaintList = __spreadArray([], (result === null || result === void 0 || (_result$payload9 = result.payload) === null || _result$payload9 === void 0 || (_result$payload9 = _result$payload9.value) === null || _result$payload9 === void 0 || (_result$payload9 = _result$payload9.data) === null || _result$payload9 === void 0 ? void 0 : _result$payload9.Complaint), true);
                        ComplaintList = ComplaintList.map(function (complaintItem) {
                            return _objectSpread(_objectSpread({}, complaintItem), {}, {
                                isExpanded: false,
                                jobType: "Complaint",
                                code: "",
                                RepeatRevisitReasonId: complaintItem.RepeatRevisitReasonId ? complaintItem.RepeatRevisitReasonId : "",
                                rootCauseCategoryId: complaintItem.RepeatRootCauseId ? complaintItem.RepeatRootCauseId : "",
                                rootCauseId: complaintItem.SpecificRepeatRootCauseId ? complaintItem.SpecificRepeatRootCauseId : "",
                                CorrectiveActionId: complaintItem.CorrectiveActionId ? complaintItem.CorrectiveActionId : ""
                            });
                        });
                    }
                    setPartLabourComplaintList(__spreadArray(__spreadArray(__spreadArray([], partList, true), labourList, true), ComplaintList, true));
                    if (!(result !== null && result !== void 0 && (_result$payload10 = result.payload) !== null && _result$payload10 !== void 0 && (_result$payload10 = _result$payload10.value) !== null && _result$payload10 !== void 0 && (_result$payload10 = _result$payload10.data) !== null && _result$payload10 !== void 0 && _result$payload10.RepeatRevisitReasonId)) return [3 /*break*/, 3];
                    setRepeatRevisitId(result === null || result === void 0 || (_result$payload11 = result.payload) === null || _result$payload11 === void 0 || (_result$payload11 = _result$payload11.value) === null || _result$payload11 === void 0 || (_result$payload11 = _result$payload11.data) === null || _result$payload11 === void 0 ? void 0 : _result$payload11.RepeatRevisitReasonId);
                    return [4 /*yield*/, getRootCauseCategoryList(result === null || result === void 0 || (_result$payload12 = result.payload) === null || _result$payload12 === void 0 || (_result$payload12 = _result$payload12.value) === null || _result$payload12 === void 0 || (_result$payload12 = _result$payload12.data) === null || _result$payload12 === void 0 ? void 0 : _result$payload12.RepeatRevisitReasonId)];
                case 2:
                    categoryList = _a.sent();
                    setRootCauseCategoryList(categoryList);
                    _a.label = 3;
                case 3:
                    if (!(result !== null && result !== void 0 && (_result$payload13 = result.payload) !== null && _result$payload13 !== void 0 && (_result$payload13 = _result$payload13.value) !== null && _result$payload13 !== void 0 && (_result$payload13 = _result$payload13.data) !== null && _result$payload13 !== void 0 && _result$payload13.RepeatRootCauseId)) return [3 /*break*/, 5];
                    setRootCauseCategoryId(result === null || result === void 0 || (_result$payload14 = result.payload) === null || _result$payload14 === void 0 || (_result$payload14 = _result$payload14.value) === null || _result$payload14 === void 0 || (_result$payload14 = _result$payload14.data) === null || _result$payload14 === void 0 ? void 0 : _result$payload14.RepeatRootCauseId);
                    return [4 /*yield*/, getRootCauseList(result === null || result === void 0 || (_result$payload15 = result.payload) === null || _result$payload15 === void 0 || (_result$payload15 = _result$payload15.value) === null || _result$payload15 === void 0 || (_result$payload15 = _result$payload15.data) === null || _result$payload15 === void 0 ? void 0 : _result$payload15.RepeatRootCauseId)];
                case 4:
                    rootCauseList_1 = _a.sent();
                    setRootCauseList(rootCauseList_1);
                    _a.label = 5;
                case 5:
                    if (!(result !== null && result !== void 0 && (_result$payload16 = result.payload) !== null && _result$payload16 !== void 0 && (_result$payload16 = _result$payload16.value) !== null && _result$payload16 !== void 0 && (_result$payload16 = _result$payload16.data) !== null && _result$payload16 !== void 0 && _result$payload16.SpecificRepeatRootCauseId)) return [3 /*break*/, 7];
                    setRootCauseId(result === null || result === void 0 || (_result$payload17 = result.payload) === null || _result$payload17 === void 0 || (_result$payload17 = _result$payload17.value) === null || _result$payload17 === void 0 || (_result$payload17 = _result$payload17.data) === null || _result$payload17 === void 0 ? void 0 : _result$payload17.SpecificRepeatRootCauseId);
                    return [4 /*yield*/, getCorrectiveActionList(result === null || result === void 0 || (_result$payload18 = result.payload) === null || _result$payload18 === void 0 || (_result$payload18 = _result$payload18.value) === null || _result$payload18 === void 0 || (_result$payload18 = _result$payload18.data) === null || _result$payload18 === void 0 ? void 0 : _result$payload18.SpecificRepeatRootCauseId)];
                case 6:
                    correctiveList = _a.sent();
                    setCorrectiveActionList(correctiveList);
                    _a.label = 7;
                case 7:
                    setCorrectiveActionId(result === null || result === void 0 || (_result$payload19 = result.payload) === null || _result$payload19 === void 0 || (_result$payload19 = _result$payload19.value) === null || _result$payload19 === void 0 || (_result$payload19 = _result$payload19.data) === null || _result$payload19 === void 0 ? void 0 : _result$payload19.CorrectiveActionId);
                    setRemarks(result === null || result === void 0 || (_result$payload20 = result.payload) === null || _result$payload20 === void 0 || (_result$payload20 = _result$payload20.value) === null || _result$payload20 === void 0 || (_result$payload20 = _result$payload20.data) === null || _result$payload20 === void 0 ? void 0 : _result$payload20.Remarks);
                    _a.label = 8;
                case 8:
                    setListLoader({
                        repeatListLoader: false,
                        categoryListLoader: false,
                        rootCauseListLoader: false,
                        correctiveActionListLoader: false
                    });
                    setPreviousJobcardLoader(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var getRepeatResonConfig = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _result$payload21, _result$payload22, selectedBranch, requestBody, result, _result$payload23;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    selectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
                    requestBody = {
                        "OrganizationId": selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: '',
                            url: RepeatRevisitConfigUrl,
                            request: requestBody
                        }))];
                case 1:
                    result = _a.sent();
                    if (result !== null && result !== void 0 && (_result$payload21 = result.payload) !== null && _result$payload21 !== void 0 && (_result$payload21 = _result$payload21.value) !== null && _result$payload21 !== void 0 && _result$payload21.success && result !== null && result !== void 0 && (_result$payload22 = result.payload) !== null && _result$payload22 !== void 0 && (_result$payload22 = _result$payload22.value) !== null && _result$payload22 !== void 0 && _result$payload22.data) {
                        // setRepeatReasonConfig(REPEAT_CONFIG)
                        setRepeatReasonConfig(result === null || result === void 0 || (_result$payload23 = result.payload) === null || _result$payload23 === void 0 || (_result$payload23 = _result$payload23.value) === null || _result$payload23 === void 0 ? void 0 : _result$payload23.data);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getCorrectiveActionList = function (rootCauseId) { return __awaiter(void 0, void 0, void 0, function () {
        var _result$payload24, _result$payload25, requestBody, result, _result$payload26;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestBody = {
                        "ParentId": rootCauseId
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: '',
                            url: CorrectiveActionsListUrl,
                            request: requestBody
                        }))];
                case 1:
                    result = _a.sent();
                    if ((_result$payload24 = result.payload) !== null && _result$payload24 !== void 0 && (_result$payload24 = _result$payload24.value) !== null && _result$payload24 !== void 0 && _result$payload24.success && (_result$payload25 = result.payload) !== null && _result$payload25 !== void 0 && (_result$payload25 = _result$payload25.value) !== null && _result$payload25 !== void 0 && _result$payload25.data) {
                        return [2 /*return*/, __spreadArray([], ((_result$payload26 = result.payload) === null || _result$payload26 === void 0 || (_result$payload26 = _result$payload26.value) === null || _result$payload26 === void 0 ? void 0 : _result$payload26.data), true)];
                    }
                    else {
                        return [2 /*return*/, []];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getRootCauseCategoryList = function (reasonId) { return __awaiter(void 0, void 0, void 0, function () {
        var _result$payload27, _result$payload28, requestBody, result, _result$payload29;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestBody = {
                        "ReasonOfRVId": reasonId
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: '',
                            url: ReapeatRootCauseCategoryListUrl,
                            request: requestBody
                        }))];
                case 1:
                    result = _a.sent();
                    if ((_result$payload27 = result.payload) !== null && _result$payload27 !== void 0 && (_result$payload27 = _result$payload27.value) !== null && _result$payload27 !== void 0 && _result$payload27.success && (_result$payload28 = result.payload) !== null && _result$payload28 !== void 0 && (_result$payload28 = _result$payload28.value) !== null && _result$payload28 !== void 0 && _result$payload28.data) {
                        return [2 /*return*/, __spreadArray([], ((_result$payload29 = result.payload) === null || _result$payload29 === void 0 || (_result$payload29 = _result$payload29.value) === null || _result$payload29 === void 0 ? void 0 : _result$payload29.data), true)];
                    }
                    else {
                        return [2 /*return*/, []];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getRootCauseList = function (rootCauseCategoryId) { return __awaiter(void 0, void 0, void 0, function () {
        var _result$payload30, _result$payload31, requestBody, result, _result$payload32;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestBody = {
                        "ParentId": rootCauseCategoryId
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: '',
                            url: ReapeatRootCauseListUrl,
                            request: requestBody
                        }))];
                case 1:
                    result = _a.sent();
                    if ((_result$payload30 = result.payload) !== null && _result$payload30 !== void 0 && (_result$payload30 = _result$payload30.value) !== null && _result$payload30 !== void 0 && _result$payload30.success && (_result$payload31 = result.payload) !== null && _result$payload31 !== void 0 && (_result$payload31 = _result$payload31.value) !== null && _result$payload31 !== void 0 && _result$payload31.data) {
                        return [2 /*return*/, __spreadArray([], ((_result$payload32 = result.payload) === null || _result$payload32 === void 0 || (_result$payload32 = _result$payload32.value) === null || _result$payload32 === void 0 ? void 0 : _result$payload32.data), true)];
                    }
                    else {
                        return [2 /*return*/, []];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (alertId && callApIStatus) {
            dispatch(showLoader({
                isLoaderOpen: true
            }));
            Promise.all([getRepeatResonConfig(), getAlertDetailsById()]).finally(function () {
                dispatch(showLoader({
                    isLoaderOpen: false
                }));
            });
        }
    }, [alertId, callApIStatus]);
    var onViewJCClick = function (e) {
        toggleDrawer();
        dispatch(setState({
            key: "preDocumentFetch",
            value: []
        }));
        dispatch(setState({
            key: "documentDetailsGetById",
            value: {}
        }));
        navigate("/jobcard-details/".concat(previousJobcard === null || previousJobcard === void 0 ? void 0 : previousJobcard.id), {
            state: {
                fromRoute: window.location.pathname
            }
        });
    };
    var handleCollapseExpand = function () {
        setIsExpand(!isExpand);
    };
    var handleCollapseExpandParent = function () {
        setIsExpandParent(!isExpandParent);
    };
    var validateLineLevelPart = function () {
        var jobTypeConfigMap = {
            Part: RepeatAlertResolutionConfiguration.LineLevelPartResolutionConfiguration,
            Labour: RepeatAlertResolutionConfiguration.LineLevelLabourResolutionConfiguration,
            Complaint: RepeatAlertResolutionConfiguration.SameLineCustomerComplaint
        };
        var messageMap = {
            Part: [],
            Labour: [],
            Complaint: []
        };
        var _loop_1 = function (PartLaourComplaintItem) {
            var Key = jobTypeConfigMap[PartLaourComplaintItem.jobType];
            var ResolutionConfiguration = repeatReasonConfig && repeatReasonConfig.ResolutionConfiguration && Array.isArray(repeatReasonConfig.ResolutionConfiguration) ? repeatReasonConfig.ResolutionConfiguration : [];
            var element = ResolutionConfiguration.find(function (item) { return item.Key === Key; });
            var isReasonValid = element && element[AlertFields.Reason] && element[AlertFields.Reason] === 'Mandatory' ? !!PartLaourComplaintItem.RepeatRevisitReasonId : true;
            var isRootCauseCategoryValid = element && element[AlertFields.RootCauseCategory] && element[AlertFields.RootCauseCategory] === 'Mandatory' ? !!PartLaourComplaintItem.rootCauseCategoryId : true;
            var isRootCauseValid = element && element[AlertFields.RootCause] && element[AlertFields.RootCause] === 'Mandatory' ? !!PartLaourComplaintItem.rootCauseId : true;
            var correctiveActionValid = element && element[AlertFields.correctiveAction] && element[AlertFields.correctiveAction] === 'Mandatory' ? !!PartLaourComplaintItem.CorrectiveActionId : true;
            var isRemarkValid = element && element[AlertFields.Remark] && element[AlertFields.Remark] === 'Mandatory' ? !!PartLaourComplaintItem.Remarks : true;
            if (!(isReasonValid && isRootCauseCategoryValid && isRootCauseValid && correctiveActionValid && isRemarkValid)) {
                messageMap[PartLaourComplaintItem.jobType] = __spreadArray(__spreadArray([], messageMap[PartLaourComplaintItem.jobType], true), [PartLaourComplaintItem.ChildName], false);
            }
        };
        for (var _i = 0, PartLabourComplaintList_1 = PartLabourComplaintList; _i < PartLabourComplaintList_1.length; _i++) {
            var PartLaourComplaintItem = PartLabourComplaintList_1[_i];
            _loop_1(PartLaourComplaintItem);
        }
        var partsMessage = messageMap.Part.length > 0 ? "Parts- ".concat(messageMap.Part.join(', ')) : '';
        var labourMessage = messageMap.Labour.length > 0 ? "Labours- ".concat(messageMap.Labour.join(', ')) : '';
        var complaintMessage = messageMap.Complaint.length > 0 ? "Complaints- ".concat(messageMap.Complaint.join(', ')) : '';
        return {
            partsMessage: partsMessage,
            labourMessage: labourMessage,
            complaintMessage: complaintMessage
        };
    };
    var validateHeaderLevel = function () {
        var messageArray = [];
        if ((repeatReasonConfig === null || repeatReasonConfig === void 0 ? void 0 : repeatReasonConfig.Type) === JC_ALERT_CONFIG_LEVELS.Both || (repeatReasonConfig === null || repeatReasonConfig === void 0 ? void 0 : repeatReasonConfig.Type) === JC_ALERT_CONFIG_LEVELS.Header) {
            var _repeatReasonConfig$R;
            var headerConfig = repeatReasonConfig === null || repeatReasonConfig === void 0 || (_repeatReasonConfig$R = repeatReasonConfig.ResolutionConfiguration) === null || _repeatReasonConfig$R === void 0 ? void 0 : _repeatReasonConfig$R.find(function (item) { return item.Key === RepeatAlertResolutionConfiguration.HeaderResolutionConfiguration; });
            if (headerConfig && headerConfig.Reason === "Mandatory" && !repeatRevisitId) {
                messageArray.push("Repeat reason");
            }
            if (headerConfig && headerConfig.RootCauseCategory === "Mandatory" && !rootCauseCategoryId) {
                messageArray.push("Root cause category");
            }
            if (headerConfig && headerConfig.RootCause === "Mandatory" && !rootCauseId) {
                messageArray.push("Root cause");
            }
            if (headerConfig && headerConfig.correctiveAction === "Mandatory" && !correctiveActionId) {
                messageArray.push("Corrective action");
            }
            if (headerConfig && headerConfig.Remark === "Mandatory" && !remarks) {
                messageArray.push("Remarks");
            }
        }
        return messageArray;
    };
    var handleSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        var validateArray, lineLevelMessage, ChildAssociations, request;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    validateArray = validateHeaderLevel();
                    if (validateArray.length > 0) {
                        GoogleAnlyticsErrorLog(profileData, 'ClientSide', "The vehicle is repeated since ".concat(validateArray.join("/ "), " is mandatory."));
                        dispatch(showNotification({
                            isOpen: true,
                            message: "The vehicle is repeated since ".concat(validateArray.join("/ "), " is mandatory."),
                            type: "error"
                        }));
                        return [2 /*return*/];
                    }
                    lineLevelMessage = validateLineLevelPart();
                    if (lineLevelMessage.partsMessage || lineLevelMessage.labourMessage || lineLevelMessage.complaintMessage) {
                        GoogleAnlyticsErrorLog(profileData, 'ClientSide', /*#__PURE__*/ React.createElement("p", null, "Please fill the mandatory repeat observations for following items:", /*#__PURE__*/ React.createElement("br", null), lineLevelMessage.partsMessage, " ", /*#__PURE__*/ React.createElement("br", null), lineLevelMessage.labourMessage, " ", /*#__PURE__*/ React.createElement("br", null), lineLevelMessage.complaintMessage));
                        dispatch(showNotification({
                            isOpen: true,
                            message: /*#__PURE__*/ React.createElement("p", null, "Please fill the mandatory repeat observations for following items:", /*#__PURE__*/ React.createElement("br", null), lineLevelMessage.partsMessage, " ", /*#__PURE__*/ React.createElement("br", null), lineLevelMessage.labourMessage, " ", /*#__PURE__*/ React.createElement("br", null), lineLevelMessage.complaintMessage),
                            type: "error"
                        }));
                        return [2 /*return*/];
                    }
                    ChildAssociations = PartLabourComplaintList.map(function (item) {
                        var ChildId = "";
                        if (item.jobType === "Part" || item.jobType === "Labour") {
                            ChildId = item.ChildId;
                        }
                        else {
                            ChildId = item.ComplaintId;
                        }
                        return {
                            "ChildId": ChildId,
                            "EntityId": item.EntityId,
                            "RepeatRevisitReasonId": item.RepeatRevisitReasonId,
                            "Remarks": item.Remarks,
                            "RepeatRootCauseId": item.rootCauseCategoryId,
                            "SpecificRepeatRootCauseId": item.rootCauseId,
                            "CorrectiveActionId": item.CorrectiveActionId
                        };
                    });
                    request = {
                        "AlertId": alertId,
                        "ParentId": jobCardId,
                        "ChildAssociations": ChildAssociations,
                        "RepeatRevisitReasonId": repeatRevisitId,
                        "RepeatRootCauseId": rootCauseCategoryId,
                        "SpecificRepeatRootCauseId": rootCauseId,
                        "CorrectiveActionId": correctiveActionId,
                        "Remarks": remarks,
                        "InstallBaseId": InstallBaseId
                    };
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: true
                        }))];
                case 1:
                    _a.sent();
                    dispatch(createAPI({
                        key: "",
                        url: JobcardAlertUpsertUrl,
                        request: request
                    })).then(function () {
                        dispatch(showNotification({
                            isOpen: true,
                            message: "Alert details updated successfully !",
                            type: "success"
                        }));
                    }).catch(function () {
                        GoogleAnlyticsErrorLog(profileData, 'ClientSide', "Alert details did not updated !");
                        dispatch(showNotification({
                            isOpen: true,
                            message: "Alert details did not updated !",
                            type: "error"
                        }));
                    }).finally(function () {
                        dispatch(showLoader({
                            isLoaderOpen: false
                        }));
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    var handleLineReasonkSelect = function (id, index) { return __awaiter(void 0, void 0, void 0, function () {
        var updatedPartLabourComplaintList, categoryList;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    updatedPartLabourComplaintList = __spreadArray([], PartLabourComplaintList, true);
                    updatedPartLabourComplaintList[index].RepeatRevisitReasonId = id;
                    updatedPartLabourComplaintList[index].rootCauseCategoryId = "";
                    updatedPartLabourComplaintList[index].rootCauseId = "";
                    updatedPartLabourComplaintList[index].CorrectiveActionId = "";
                    if (!id) return [3 /*break*/, 2];
                    setListLoader(_objectSpread(_objectSpread({}, listLoader), {}, {
                        categoryListLoader: true,
                        rootCauseListLoader: true,
                        correctiveActionListLoader: true
                    }));
                    return [4 /*yield*/, getRootCauseCategoryList(id)];
                case 1:
                    categoryList = _a.sent();
                    setListLoader({
                        repeatListLoader: false,
                        categoryListLoader: false,
                        rootCauseListLoader: false,
                        correctiveActionListLoader: false
                    });
                    updatedPartLabourComplaintList[index].rootCauseCategoryList = categoryList;
                    _a.label = 2;
                case 2:
                    setPartLabourComplaintList(updatedPartLabourComplaintList);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleLineLevelRootCauseCategorySelect = function (id, index) { return __awaiter(void 0, void 0, void 0, function () {
        var updatedPartLabourComplaintList, rootCauseList_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    updatedPartLabourComplaintList = __spreadArray([], PartLabourComplaintList, true);
                    updatedPartLabourComplaintList[index].rootCauseCategoryId = id;
                    updatedPartLabourComplaintList[index].rootCauseId = "";
                    updatedPartLabourComplaintList[index].CorrectiveActionId = "";
                    if (!id) return [3 /*break*/, 2];
                    setListLoader(_objectSpread(_objectSpread({}, listLoader), {}, {
                        rootCauseListLoader: true,
                        correctiveActionListLoader: true
                    }));
                    return [4 /*yield*/, getRootCauseList(id)];
                case 1:
                    rootCauseList_2 = _a.sent();
                    setListLoader({
                        repeatListLoader: false,
                        categoryListLoader: false,
                        rootCauseListLoader: false,
                        correctiveActionListLoader: false
                    });
                    updatedPartLabourComplaintList[index].rootCauseList = rootCauseList_2;
                    _a.label = 2;
                case 2:
                    setPartLabourComplaintList(updatedPartLabourComplaintList);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleLineLevelRootCauseSelect = function (id, index) { return __awaiter(void 0, void 0, void 0, function () {
        var updatedPartLabourComplaintList, correctiveList;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    updatedPartLabourComplaintList = __spreadArray([], PartLabourComplaintList, true);
                    updatedPartLabourComplaintList[index].rootCauseId = id;
                    updatedPartLabourComplaintList[index].CorrectiveActionId = "";
                    if (!id) return [3 /*break*/, 2];
                    setListLoader(_objectSpread(_objectSpread({}, listLoader), {}, {
                        correctiveActionListLoader: true
                    }));
                    return [4 /*yield*/, getCorrectiveActionList(id)];
                case 1:
                    correctiveList = _a.sent();
                    setListLoader({
                        repeatListLoader: false,
                        categoryListLoader: false,
                        rootCauseListLoader: false,
                        correctiveActionListLoader: false
                    });
                    updatedPartLabourComplaintList[index].correctiveActionList = correctiveList;
                    _a.label = 2;
                case 2:
                    setPartLabourComplaintList(updatedPartLabourComplaintList);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleLineLevelCorrectiveActionSelect = function (id, index) {
        var updatedPartLabourComplaintList = __spreadArray([], PartLabourComplaintList, true);
        updatedPartLabourComplaintList[index].CorrectiveActionId = id;
        setPartLabourComplaintList(updatedPartLabourComplaintList);
    };
    var handleLineLevelRemarkEnter = function (remarks, index) {
        var updatedPartLabourComplaintList = __spreadArray([], PartLabourComplaintList, true);
        updatedPartLabourComplaintList[index].Remarks = remarks;
        setPartLabourComplaintList(updatedPartLabourComplaintList);
    };
    var handleOpenLineLevelItem = function (index) { return __awaiter(void 0, void 0, void 0, function () {
        var list, updatedListItem, categoryList, rootCauseList_3, correctiveList;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    list = __spreadArray([], PartLabourComplaintList, true);
                    updatedListItem = _objectSpread({}, list[index]);
                    if (!!updatedListItem.isExpanded) return [3 /*break*/, 7];
                    if (!updatedListItem.RepeatRevisitReasonId) return [3 /*break*/, 2];
                    return [4 /*yield*/, getRootCauseCategoryList(updatedListItem.RepeatRevisitReasonId)];
                case 1:
                    categoryList = _a.sent();
                    updatedListItem.rootCauseCategoryList = categoryList;
                    _a.label = 2;
                case 2:
                    if (!updatedListItem.RepeatRootCauseId) return [3 /*break*/, 4];
                    return [4 /*yield*/, getRootCauseList(updatedListItem.RepeatRootCauseId)];
                case 3:
                    rootCauseList_3 = _a.sent();
                    updatedListItem.rootCauseCategoryId = updatedListItem.RepeatRootCauseId;
                    updatedListItem.rootCauseList = rootCauseList_3;
                    _a.label = 4;
                case 4:
                    if (!updatedListItem.SpecificRepeatRootCauseId) return [3 /*break*/, 6];
                    return [4 /*yield*/, getCorrectiveActionList(updatedListItem.SpecificRepeatRootCauseId)];
                case 5:
                    correctiveList = _a.sent();
                    updatedListItem.rootCauseId = updatedListItem.SpecificRepeatRootCauseId;
                    updatedListItem.correctiveActionList = correctiveList;
                    updatedListItem.CorrectiveActionId = updatedListItem.CorrectiveActionId;
                    _a.label = 6;
                case 6:
                    list[index] = updatedListItem;
                    _a.label = 7;
                case 7:
                    list = list.map(function (item, iteratorIndex) {
                        return _objectSpread(_objectSpread({}, item), {}, {
                            isExpanded: index === iteratorIndex ? !list[index].isExpanded : false
                        });
                    });
                    setPartLabourComplaintList(list);
                    return [2 /*return*/];
            }
        });
    }); };
    var showLineLevelItem = function (item) {
        var show = false;
        if (item.jobType === "Part") {
            var _repeatReasonConfig$A;
            var SamePartValue = repeatReasonConfig === null || repeatReasonConfig === void 0 || (_repeatReasonConfig$A = repeatReasonConfig.AdditionalDefination) === null || _repeatReasonConfig$A === void 0 ? void 0 : _repeatReasonConfig$A.find(function (item) { return item.Key === RepeatAlertConfigAdditionalDefination.SameParts; });
            if (SamePartValue && SamePartValue.Value) {
                show = true;
            }
        }
        else if (item.jobType === "Labour") {
            var _repeatReasonConfig$A2;
            var SameLabourValue = repeatReasonConfig === null || repeatReasonConfig === void 0 || (_repeatReasonConfig$A2 = repeatReasonConfig.AdditionalDefination) === null || _repeatReasonConfig$A2 === void 0 ? void 0 : _repeatReasonConfig$A2.find(function (item) { return item.Key === RepeatAlertConfigAdditionalDefination.SameLabour; });
            if (SameLabourValue && SameLabourValue.Value) {
                show = true;
            }
        }
        else if (item.jobType === 'Complaint') {
            var _repeatReasonConfig$A3;
            var SameComplaintValue = repeatReasonConfig === null || repeatReasonConfig === void 0 || (_repeatReasonConfig$A3 = repeatReasonConfig.AdditionalDefination) === null || _repeatReasonConfig$A3 === void 0 ? void 0 : _repeatReasonConfig$A3.find(function (item) { return item.Key === RepeatAlertConfigAdditionalDefination.SameCustomerComplaint; });
            if (SameComplaintValue && SameComplaintValue.Value) {
                show = true;
            }
        }
        return show;
    };
    var getMandtoryMark = function (JobType, field) {
        var jobTypeConfigMap = {
            Part: RepeatAlertResolutionConfiguration.LineLevelPartResolutionConfiguration,
            Labour: RepeatAlertResolutionConfiguration.LineLevelLabourResolutionConfiguration,
            Complaint: RepeatAlertResolutionConfiguration.SameLineCustomerComplaint
        };
        var Key = jobTypeConfigMap[JobType];
        var ResolutionConfiguration = repeatReasonConfig && repeatReasonConfig.ResolutionConfiguration && Array.isArray(repeatReasonConfig.ResolutionConfiguration) ? repeatReasonConfig.ResolutionConfiguration : [];
        var element = ResolutionConfiguration.find(function (item) { return item.Key === Key; });
        return element && element[field] && element[field] === 'Mandatory';
    };
    var getMandtoryMarkHeader = function (field) {
        var Key = RepeatAlertResolutionConfiguration.HeaderResolutionConfiguration;
        var ResolutionConfiguration = repeatReasonConfig && repeatReasonConfig.ResolutionConfiguration && Array.isArray(repeatReasonConfig.ResolutionConfiguration) ? repeatReasonConfig.ResolutionConfiguration : [];
        var element = ResolutionConfiguration.find(function (item) { return item.Key === Key; });
        return element && element[field] && element[field] === 'Mandatory';
    };
    return /*#__PURE__*/ React.createElement(Grid, {
        container: true
    }, previousJobcardLoader ? /*#__PURE__*/ React.createElement(MuiStack, {
        borderRadius: '8px',
        direction: 'column',
        style: {
            width: '100%',
            height: '350px'
        }
    }, /*#__PURE__*/ React.createElement(Skeleton, {
        variant: "rounded",
        animation: "wave",
        width: "100%",
        height: '100%'
    })) : /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 12,
        md: 12
    }, alertDetails ? /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        sx: {
            border: "1px solid ".concat(faintGray),
            borderRadius: "8px"
        }
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 12,
        md: 12,
        sx: {
            backgroundColor: '#E6F2FF',
            borderRadius: isExpand ? "8px 8px 0px 0px" : "8px"
        }
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        p: '12px 16px 12px 16px',
        spacing: 2
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: 2
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 12,
        md: 12
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        color: gray
    }, "Previous job card"), /*#__PURE__*/ React.createElement(Typography, {
        id: "prev-jc-no",
        variant: "h5",
        color: mobilenoblack
    }, alertDetails === null || alertDetails === void 0 ? void 0 : alertDetails.SourceDocumentNo), /*#__PURE__*/ React.createElement(Typography, {
        id: "prev-jc-date",
        variant: "subtitle2",
        color: mobilenoblack
    }, alertDetails && alertDetails.UpdatedOn ? moment(alertDetails.UpdatedOn).format('DD MMM, YYYY') : '-')))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 12,
        md: 12
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        color: gray
    }, "Dealer information:")), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6,
        sm: 6,
        md: 6
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: "dealer-name",
        variant: "h5",
        color: mobilenoblack
    }, alertDetails && alertDetails.OrganizationName ? alertDetails.OrganizationName : "-")), alertDetails && alertDetails.OrganizationAddress && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 12,
        md: 12
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: "prev-jc-address",
        variant: "subtitle2",
        color: mobilenoblack
    }, "".concat((_alertDetails$Organiz = alertDetails.OrganizationAddress.Address1) !== null && _alertDetails$Organiz !== void 0 ? _alertDetails$Organiz : "", " ").concat((_alertDetails$Organiz2 = alertDetails.OrganizationAddress.CityName) !== null && _alertDetails$Organiz2 !== void 0 ? _alertDetails$Organiz2 : "", " ").concat((_alertDetails$Organiz3 = alertDetails.OrganizationAddress.StateName) !== null && _alertDetails$Organiz3 !== void 0 ? _alertDetails$Organiz3 : "", " ").concat((_alertDetails$Organiz4 = alertDetails.OrganizationAddress.Zip) !== null && _alertDetails$Organiz4 !== void 0 ? _alertDetails$Organiz4 : ""))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 12,
        md: 12,
        pt: 2
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        color: gray
    }, "Service advisor :")), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 12,
        md: 12
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: "prev-jc-advisor",
        variant: "h6",
        color: mobilenoblack
    }, alertDetails && alertDetails.ServiceAdvisorGivenName && alertDetails.ServiceAdvisorFamilyName ? alertDetails.ServiceAdvisorGivenName + ' ' + alertDetails.ServiceAdvisorFamilyName : "-")), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 12,
        md: 12,
        sx: {
            display: 'flex',
            gap: '10px',
            placeItems: 'center'
        }
    }, /*#__PURE__*/ React.createElement(Img, {
        id: "mobile-no",
        src: PhoneIcon,
        alt: "settingIcon",
        onClick: function (event) {
            if (alertDetails !== null && alertDetails !== void 0 && alertDetails.ServiceAdvisorMobileNumber) {
                event.stopPropagation();
                handleMobileNoPhoneCall(Number(alertDetails.ServiceAdvisorMobileNumber));
            }
        }
    }), /*#__PURE__*/ React.createElement(Typography, {
        id: "prev-sa-mobile-no",
        variant: "h6",
        color: gray
    }, alertDetails && alertDetails.ServiceAdvisorMobileNumber ? alertDetails.ServiceAdvisorMobileNumber : "-"), /*#__PURE__*/ React.createElement(MuiStack, {
        sx: {
            border: "1px solid ".concat(faintGray),
            height: '16px'
        }
    })), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 12,
        md: 12,
        pt: 2
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        color: gray
    }, "Previous KM:")), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 12,
        md: 12
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: "prev-km-reading",
        variant: "h6",
        color: mobilenoblack
    }, alertDetails && alertDetails.ODOMeterReading ? alertDetails.ODOMeterReading : "-"))))))) : /*#__PURE__*/ React.createElement(MuiStack, {
        height: "100%",
        justifyContent: "center",
        alignItems: "center"
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: "revisit-no-data-found",
        variant: "h3"
    }, t("No Data Found")))), PartLabourComplaintList.length > 0 && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 12,
        md: 12
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        py: 1,
        rowGap: 2
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 12,
        md: 12
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h5"
    }, "Repeat Info  :")), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 12,
        md: 12,
        p: 1,
        sx: {
            backgroundColor: faintblue,
            borderRadius: '8px',
            border: '1px solid #DEE4EB'
        }
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true
    }, PartLabourComplaintList.map(function (item, index) {
        var _item$jobType, _item$jobType2, _item$rootCauseCatego, _item$rootCauseList, _item$correctiveActio;
        if (!showLineLevelItem(item)) {
            return;
        }
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            sm: 12,
            md: 12,
            sx: {
                display: 'flex',
                gap: '10px',
                alignItems: 'center'
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            id: "child-name",
            variant: "h5",
            color: mobilenoblack
        }, item.ChildName), /*#__PURE__*/ React.createElement(MuiStack, {
            sx: {
                border: '1px solid #AFD5FF',
                borderRadius: '11px',
                height: '22px',
                width: '24px',
                justifyContent: 'center',
                placeItems: 'center',
                backgroundColor: "#EEF6FF"
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            id: item === null || item === void 0 || (_item$jobType = item.jobType) === null || _item$jobType === void 0 ? void 0 : _item$jobType.substring(0, 1),
            variant: "h5",
            color: "#3697FF"
        }, item === null || item === void 0 || (_item$jobType2 = item.jobType) === null || _item$jobType2 === void 0 ? void 0 : _item$jobType2.substring(0, 1)))), (item === null || item === void 0 ? void 0 : item.jobType) !== "Complaint" && /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            sm: 12,
            md: 12
        }, /*#__PURE__*/ React.createElement(Typography, {
            id: item === null || item === void 0 ? void 0 : item.code,
            variant: "h6",
            color: gray
        }, "#", item === null || item === void 0 ? void 0 : item.code)), repeatReasonConfig && repeatReasonConfig.Type && (repeatReasonConfig.Type === JC_ALERT_CONFIG_LEVELS.Line || repeatReasonConfig.Type === JC_ALERT_CONFIG_LEVELS.Both) && /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            sm: 12,
            md: 12
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            alignItems: 'center'
        }, /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(MuiButton, {
            name: "Enter reason",
            variant: "text",
            size: "small",
            sx: {
                bgcolor: "transparent",
                minWidth: 'auto',
                padding: 0
            },
            onClick: function () {
                handleOpenLineLevelItem(index);
            }
        })), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(IconButton, {
            onClick: function () {
                handleOpenLineLevelItem(index);
            }
        }, /*#__PURE__*/ React.createElement("img", {
            id: item.isExpanded ? 'ArrowUPIcon' : 'ArrowDownIcon',
            src: item.isExpanded ? ArrowUPIcon : ArrowDownIcon,
            alt: "toggle",
            width: "16px",
            height: "16px"
        }))))), item.isExpanded && /*#__PURE__*/ React.createElement(React.Fragment, null, REPEAT_SHOW_HIDE_CONFIG.LINE_LEVEL.Reason && /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            md: 12,
            sm: 12,
            pt: 1
        }, /*#__PURE__*/ React.createElement(Grid, {
            container: true
        }, /*#__PURE__*/ React.createElement(Grid, null, /*#__PURE__*/ React.createElement(Typography, {
            id: t("Repeat reason"),
            variant: "h5",
            paddingY: 1
        }, t("Repeat reason"))), /*#__PURE__*/ React.createElement(Grid, null, getMandtoryMark(item.jobType, AlertFields.Reason) && /*#__PURE__*/ React.createElement(Typography, {
            color: systemColor.error,
            variant: "h5",
            paddingY: 1
        }, t("*")))), listLoader.repeatListLoader ? /*#__PURE__*/ React.createElement(MuiStack, {
            height: '40px',
            marginY: 1,
            width: '100%'
        }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)) : /*#__PURE__*/ React.createElement(MuiSelectComponent, {
            disabled: isDocumentDisabled,
            id: "repeatReason",
            options: repeatRevisitReasonListLineLevel !== null && repeatRevisitReasonListLineLevel !== void 0 ? repeatRevisitReasonListLineLevel : [],
            fullWidth: true,
            name: "repeatReason",
            displayExpr: "DisplayName",
            valueExpr: "RepeatReasonId",
            value: item.RepeatRevisitReasonId,
            onChange: function (event) {
                var id = event.target.value ? event.target.value : "";
                handleLineReasonkSelect(id, index);
            },
            caption: 'repeat reason'
        })), REPEAT_SHOW_HIDE_CONFIG.LINE_LEVEL.RootCauseCategory && /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            md: 12,
            sm: 12,
            pt: 1
        }, /*#__PURE__*/ React.createElement(Grid, {
            container: true,
            direction: 'row'
        }, /*#__PURE__*/ React.createElement(Grid, {
            item: true
        }, /*#__PURE__*/ React.createElement(Typography, {
            id: t("Root cause category"),
            variant: "h5",
            paddingY: 1
        }, t("Root cause category"))), /*#__PURE__*/ React.createElement(Grid, {
            item: true
        }, getMandtoryMark(item.jobType, AlertFields.RootCauseCategory) && /*#__PURE__*/ React.createElement(Typography, {
            color: systemColor.error,
            variant: "h5",
            paddingY: 1
        }, t("*")))), listLoader.categoryListLoader ? /*#__PURE__*/ React.createElement(MuiStack, {
            height: '40px',
            marginY: 1,
            width: '100%'
        }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)) : /*#__PURE__*/ React.createElement(MuiSelectComponent, {
            disabled: isDocumentDisabled,
            id: "rootCauseCategory",
            options: (_item$rootCauseCatego = item.rootCauseCategoryList) !== null && _item$rootCauseCatego !== void 0 ? _item$rootCauseCatego : [],
            fullWidth: true,
            name: "rootCauseCategory",
            displayExpr: "DisplayName",
            valueExpr: "id",
            value: item.rootCauseCategoryId,
            onChange: function (event) {
                var id = event.target.value ? event.target.value : "";
                handleLineLevelRootCauseCategorySelect(id, index);
            },
            caption: t("root cause category")
        })), REPEAT_SHOW_HIDE_CONFIG.LINE_LEVEL.RootCause && /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            md: 12,
            sm: 12,
            pt: 1
        }, /*#__PURE__*/ React.createElement(Grid, {
            container: true
        }, /*#__PURE__*/ React.createElement(Grid, null, /*#__PURE__*/ React.createElement(Typography, {
            id: t("Root cause"),
            variant: "h5",
            paddingY: 1
        }, t("Root cause"))), /*#__PURE__*/ React.createElement(Grid, null, getMandtoryMark(item.jobType, AlertFields.RootCause) && /*#__PURE__*/ React.createElement(Typography, {
            color: systemColor.error,
            variant: "h5",
            paddingY: 1
        }, t("*")))), listLoader.rootCauseListLoader ? /*#__PURE__*/ React.createElement(MuiStack, {
            height: '40px',
            marginY: 1,
            width: '100%'
        }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)) : /*#__PURE__*/ React.createElement(MuiSelectComponent, {
            disabled: isDocumentDisabled,
            id: "rootCause",
            options: (_item$rootCauseList = item.rootCauseList) !== null && _item$rootCauseList !== void 0 ? _item$rootCauseList : [],
            fullWidth: true,
            name: "rootCause",
            displayExpr: "SpecificName",
            valueExpr: "id",
            value: item.rootCauseId,
            onChange: function (event) {
                var id = event.target.value ? event.target.value : "";
                handleLineLevelRootCauseSelect(id, index);
            },
            caption: t("root cause")
        })), REPEAT_SHOW_HIDE_CONFIG.LINE_LEVEL.correctiveAction && /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            md: 12,
            sm: 12,
            pt: 1
        }, /*#__PURE__*/ React.createElement(Grid, {
            container: true
        }, /*#__PURE__*/ React.createElement(Grid, null, /*#__PURE__*/ React.createElement(Typography, {
            id: t("Corrective action"),
            variant: "h5",
            paddingY: 1
        }, t("Corrective action"))), /*#__PURE__*/ React.createElement(Grid, null, getMandtoryMark(item.jobType, AlertFields.correctiveAction) && /*#__PURE__*/ React.createElement(Typography, {
            color: systemColor.error,
            variant: "h5",
            paddingY: 1
        }, t("*")))), listLoader.correctiveActionListLoader ? /*#__PURE__*/ React.createElement(MuiStack, {
            height: '40px',
            marginY: 1,
            width: '100%'
        }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)) : /*#__PURE__*/ React.createElement(MuiSelectComponent, {
            disabled: isDocumentDisabled,
            id: "correctiveAction",
            options: (_item$correctiveActio = item.correctiveActionList) !== null && _item$correctiveActio !== void 0 ? _item$correctiveActio : [],
            fullWidth: true,
            name: "correctiveAction",
            displayExpr: "DisplayName",
            valueExpr: "id",
            value: item.CorrectiveActionId,
            onChange: function (event) {
                var id = event.target.value ? event.target.value : "";
                handleLineLevelCorrectiveActionSelect(id, index);
            },
            caption: t("corrective action")
        })), REPEAT_SHOW_HIDE_CONFIG.LINE_LEVEL.Remark && /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            md: 12,
            sm: 12,
            pt: 1
        }, /*#__PURE__*/ React.createElement(Grid, {
            container: true
        }, /*#__PURE__*/ React.createElement(Grid, null, /*#__PURE__*/ React.createElement(Typography, {
            id: t("Remarks"),
            variant: "h5",
            paddingY: 1
        }, t("Remarks"))), /*#__PURE__*/ React.createElement(Grid, null, getMandtoryMark(item.jobType, AlertFields.Remark) && /*#__PURE__*/ React.createElement(Typography, {
            color: systemColor.error,
            variant: "h5",
            paddingY: 1
        }, t("*")))), /*#__PURE__*/ React.createElement(InputBox, {
            disabled: isDocumentDisabled,
            tabIndex: 1,
            value: item.Remarks,
            onChange: function (event) {
                var remark = event.target.value ? event.target.value : "";
                handleLineLevelRemarkEnter(remark, index);
            },
            placeholder: t('Enter Remarks'),
            fullWidth: true,
            size: "small"
            // value={values?.remarks}
            ,
            name: "remarks"
            // onChange={handleInputChange}
            // error={errors?.remarks}
            ,
            sx: {
                "& .MuiInputBase-root": {
                    backgroundColor: "#ffff",
                    borderRadius: '8px'
                }
            },
            id: "remarks"
        }))), index !== PartLabourComplaintList.length - 1 && /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            md: 12,
            sm: 12,
            py: 2
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            sx: {
                borderTop: "1px solid ".concat(faintGray)
            }
        })));
    }))))), repeatReasonConfig && repeatReasonConfig.Type && (repeatReasonConfig.Type === JC_ALERT_CONFIG_LEVELS.Header || repeatReasonConfig.Type === JC_ALERT_CONFIG_LEVELS.Both) && !isCreateDocumentFlow && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        md: 12,
        sm: 12,
        pt: 1
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3"
    }, t("Observations"))), REPEAT_SHOW_HIDE_CONFIG.HEADER_LEVEL.Reason && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        md: 12,
        sm: 12,
        pt: 1
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true
    }, /*#__PURE__*/ React.createElement(Grid, null, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h5",
        paddingY: 1
    }, t("Repeat reason"))), /*#__PURE__*/ React.createElement(Grid, null, getMandtoryMarkHeader(AlertFields.Reason) && /*#__PURE__*/ React.createElement(Typography, {
        color: systemColor.error,
        variant: "h5",
        paddingY: 1
    }, t("*")))), /*#__PURE__*/ React.createElement(MuiSelectComponent, {
        disabled: isDocumentDisabled,
        id: "repeatReason",
        options: repeatRevisitReasonListHeaderLevel !== null && repeatRevisitReasonListHeaderLevel !== void 0 ? repeatRevisitReasonListHeaderLevel : [],
        fullWidth: true,
        name: "repeatReason",
        displayExpr: "DisplayName",
        valueExpr: "ReasonOfRVId",
        value: repeatRevisitId,
        onChange: function (event) { return __awaiter(void 0, void 0, void 0, function () {
            var id, categoryList;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        id = event.target.value ? event.target.value : "";
                        setRepeatRevisitId(id);
                        setRootCauseCategoryId("");
                        setRootCauseId("");
                        setCorrectiveActionId("");
                        if (!id) return [3 /*break*/, 2];
                        setListLoader(_objectSpread(_objectSpread({}, listLoader), {}, {
                            categoryListLoader: true,
                            rootCauseListLoader: true,
                            correctiveActionListLoader: true
                        }));
                        return [4 /*yield*/, getRootCauseCategoryList(id)];
                    case 1:
                        categoryList = _a.sent();
                        setRootCauseCategoryList(categoryList);
                        setListLoader(_objectSpread(_objectSpread({}, listLoader), {}, {
                            categoryListLoader: false,
                            rootCauseListLoader: false,
                            correctiveActionListLoader: false
                        }));
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); },
        caption: t("repeat reason")
    })), REPEAT_SHOW_HIDE_CONFIG.HEADER_LEVEL.RootCauseCategory && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        md: 12,
        sm: 12,
        pt: 1
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true
    }, /*#__PURE__*/ React.createElement(Grid, null, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h5",
        paddingY: 1
    }, t("Root cause category"))), /*#__PURE__*/ React.createElement(Grid, null, getMandtoryMarkHeader(AlertFields.RootCauseCategory) && /*#__PURE__*/ React.createElement(Typography, {
        color: systemColor.error,
        variant: "h5",
        paddingY: 1
    }, t("*")))), listLoader.categoryListLoader ? /*#__PURE__*/ React.createElement(MuiStack, {
        height: '40px',
        marginY: 1,
        width: '100%'
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)) : /*#__PURE__*/ React.createElement(MuiSelectComponent, {
        disabled: isDocumentDisabled,
        id: "rootCauseCategory",
        options: rootCauseCategoryList !== null && rootCauseCategoryList !== void 0 ? rootCauseCategoryList : [],
        fullWidth: true,
        name: "rootCauseCategory",
        displayExpr: "DisplayName",
        valueExpr: "id",
        value: rootCauseCategoryId,
        onChange: function (event) { return __awaiter(void 0, void 0, void 0, function () {
            var id, rootCauses;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        id = event.target.value ? event.target.value : "";
                        setRootCauseCategoryId(id);
                        setRootCauseId("");
                        setCorrectiveActionId("");
                        if (!id) return [3 /*break*/, 2];
                        setListLoader(_objectSpread(_objectSpread({}, listLoader), {}, {
                            rootCauseListLoader: true,
                            correctiveActionListLoader: true
                        }));
                        return [4 /*yield*/, getRootCauseList(id)];
                    case 1:
                        rootCauses = _a.sent();
                        setRootCauseList(rootCauses);
                        setListLoader(_objectSpread(_objectSpread({}, listLoader), {}, {
                            rootCauseListLoader: false,
                            correctiveActionListLoader: false
                        }));
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); },
        caption: t("root cause category")
    })), REPEAT_SHOW_HIDE_CONFIG.HEADER_LEVEL.RootCause && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        md: 12,
        sm: 12,
        pt: 1
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true
    }, /*#__PURE__*/ React.createElement(Grid, null, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h5",
        paddingY: 1
    }, t("Root cause"))), /*#__PURE__*/ React.createElement(Grid, null, getMandtoryMarkHeader(AlertFields.RootCause) && /*#__PURE__*/ React.createElement(Typography, {
        color: systemColor.error,
        variant: "h5",
        paddingY: 1
    }, t("*")))), listLoader.rootCauseListLoader ? /*#__PURE__*/ React.createElement(MuiStack, {
        height: '40px',
        marginY: 1,
        width: '100%'
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)) : /*#__PURE__*/ React.createElement(MuiSelectComponent, {
        disabled: isDocumentDisabled,
        id: "rootCause",
        options: rootCauseList !== null && rootCauseList !== void 0 ? rootCauseList : [],
        fullWidth: true,
        name: "rootCause",
        displayExpr: "SpecificName",
        valueExpr: "id",
        value: rootCauseId,
        onChange: function (event) { return __awaiter(void 0, void 0, void 0, function () {
            var id, correctiveActions;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        id = event.target.value ? event.target.value : "";
                        setRootCauseId(id);
                        setCorrectiveActionId("");
                        if (!id) return [3 /*break*/, 2];
                        setListLoader(_objectSpread(_objectSpread({}, listLoader), {}, {
                            correctiveActionListLoader: true
                        }));
                        return [4 /*yield*/, getCorrectiveActionList(id)];
                    case 1:
                        correctiveActions = _a.sent();
                        setCorrectiveActionList(correctiveActions);
                        setListLoader(_objectSpread(_objectSpread({}, listLoader), {}, {
                            correctiveActionListLoader: false
                        }));
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); },
        caption: t("root cause")
    })), REPEAT_SHOW_HIDE_CONFIG.HEADER_LEVEL.correctiveAction && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        md: 12,
        sm: 12,
        pt: 1
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true
    }, /*#__PURE__*/ React.createElement(Grid, null, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h5",
        paddingY: 1
    }, t("Corrective action"))), /*#__PURE__*/ React.createElement(Grid, null, getMandtoryMarkHeader(AlertFields.correctiveAction) && /*#__PURE__*/ React.createElement(Typography, {
        color: systemColor.error,
        variant: "h5",
        paddingY: 1
    }, t("*")))), listLoader.correctiveActionListLoader ? /*#__PURE__*/ React.createElement(MuiStack, {
        height: '40px',
        marginY: 1,
        width: '100%'
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)) : /*#__PURE__*/ React.createElement(MuiSelectComponent, {
        disabled: isDocumentDisabled,
        id: "rootCause",
        options: correctiveActionList !== null && correctiveActionList !== void 0 ? correctiveActionList : [],
        fullWidth: true,
        name: "rootCause",
        displayExpr: "DisplayName",
        valueExpr: "id",
        value: correctiveActionId,
        onChange: function (event) {
            var id = event.target.value ? event.target.value : "";
            setCorrectiveActionId(id);
        },
        caption: t("corrective action")
    })), REPEAT_SHOW_HIDE_CONFIG.HEADER_LEVEL.Remark && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        md: 12,
        sm: 12,
        pt: 1
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true
    }, /*#__PURE__*/ React.createElement(Grid, null, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h5",
        paddingY: 1
    }, t("Remarks"))), /*#__PURE__*/ React.createElement(Grid, null, getMandtoryMarkHeader(AlertFields.Remark) && /*#__PURE__*/ React.createElement(Typography, {
        color: systemColor.error,
        variant: "h5",
        paddingY: 1
    }, t("*")))), /*#__PURE__*/ React.createElement(InputBox, {
        disabled: isDocumentDisabled,
        tabIndex: 1,
        value: remarks,
        onChange: function (event) {
            setRemarks(event.target.value);
        },
        placeholder: t('Enter Remarks'),
        fullWidth: true,
        size: "small"
        // value={values?.remarks}
        ,
        name: "remarks"
        // onChange={handleInputChange}
        // error={errors?.remarks}
        // sx={{
        //     "& .MuiInputBase-root.Mui-disabled": {
        //         backgroundColor: "#ffff",
        //         borderRadius: '8px'
        //     }
        // }}
        ,
        id: "remarks"
    }))), !isCreateDocumentFlow && alertDetails && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        md: 12,
        sm: 12,
        py: 2
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        sx: {
            border: "1px solid ".concat(faintGray)
        }
    })), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        md: 12,
        sm: 12,
        sx: {
            textAlign: 'end'
        }
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        variant: "contained",
        size: "medium",
        name: "Save",
        disabled: isDocumentDisabled,
        onClick: function (e) { return handleSave(); }
    }))));
};
